import {
  useCompositeSeparator
} from "../__chunks/POSBQXS7.js";
import "../__chunks/KPEUI6QX.js";
import "../__chunks/Z3X3QN6P.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/5ETIGB6O.js";
import "../__chunks/4BKCJXBM.js";

// src/menu/menu-separator.ts
var useMenuSeparator = createHook((props) => {
  props = useCompositeSeparator(props);
  return props;
});
var MenuSeparator = createComponent((props) => {
  const htmlProps = useMenuSeparator(props);
  return createElement("hr", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  MenuSeparator.displayName = "MenuSeparator";
}
export {
  MenuSeparator,
  useMenuSeparator
};
